<template>
  <section class="container-support">
    Hello
  </section>
</template>

<script>

export default {

};

</script>

<style lang="scss" scoped>
.container-support {
    display: flex;
    width: 100%;
    height: 100vh;
    background-color: #FFF;
}
</style>
